module.exports = __webpack_public_path__ + "img/694-e9a8ac.png";